import { render } from "./ChooseServer.vue?vue&type=template&id=029d660f&scoped=true&ts=true"
import script from "./ChooseServer.vue?vue&type=script&lang=ts"
export * from "./ChooseServer.vue?vue&type=script&lang=ts"

import "./ChooseServer.vue?vue&type=style&index=0&id=029d660f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029d660f"]])

export default __exports__